/**
 * Encode a pair to `key=value` string.
 * @param {string} key The URL search key
 * @param {string} value The URL search value
 */
export const entryToSearch = (key, value) =>
  `${key}=${encodeURIComponent(value)}`;

/**
 * Transform `entries` to URL search params
 * @param {Array<[string, string]>} entries Array of entries
 */
export const entriesToSearch = entries => entries.flatMap(
  ([key, value]) => Array.isArray(value)
    ? value.map(v => entryToSearch(`${encodeURIComponent(key)}[]`, v))
    : entryToSearch(encodeURIComponent(key), value)
).join('&');

export const jsonToSearch = obj => entriesToSearch(Object.entries(obj));

/**
 * Checks if key has trailing `[]`.
 * @param {string} key The URL search key
 */
export const isArrayKey = key => key.endsWith('[]');

/**
 * Remove the trailing `[]` in key if it exists.
 * @param {string} key The URL Search key
 */
export const resolveKey = key => isArrayKey(key) ? key.slice(0, -2) : key;

/**
 * Transform an URL search (`key=val&other=val&this[]=val&this[]=other`) to equivalent JSON.
 * @param {string} query The URL search query
 */
export const searchToJSON = query => query
  .split('&')
  .map(param => param.split('='))
  .reduce((obj, [_key, val]) => {
    const isArray = isArrayKey(_key);
    const key = decodeURIComponent(resolveKey(_key));
    const finalValue = isArray
      ? [].concat(obj[key] || [], decodeURIComponent(val))
      : decodeURIComponent(val);

    return Object.assign(obj, { [key]: finalValue });
  }, {});
